import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Distributor } from "../../views/distributor/Distributor";
import { Home } from "../../views/home/home";
import { IndustryDetail } from "../../views/industry/IndustryDetail";
import { IndustryList } from "../../views/industry/IndustryList";
import { NewsDetail } from "../../views/news/NewsDetail";
import { NewsList } from "../../views/news/NewsList";
import { Newsroom } from "../../views/news/Newsroom";
import { Company } from "../../views/page/Company";
import { Histroy } from "../../views/page/Histroy";
import { Registration } from "../../views/page/Registration";
import { ProductDetail } from "../../views/product/ProductDetail";
import { TypeDetail } from "../../views/product/TypeDetail";
import { TypeList } from "../../views/product/TypeList";
import { SuccessStoryDetail } from "../../views/successStory/SuccessStoryDetail";
import { BasicLayout } from "../layout/BasicLayout";

function BasicRoute() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<BasicLayout />} >
                    <Route path="/" element={<Home />} />
                    <Route path="/industries" element={<IndustryList />} />
                    <Route path="/industry/:id" element={<IndustryDetail />} />
                    <Route path="/products" element={<TypeList />} />
                    <Route path="/type/:id" element={<TypeDetail />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/distributor" element={<Distributor />} />
                    <Route path="/newsroom" element={<Newsroom />} />
                    <Route path="/news-type/:id" element={<NewsList />} />
                    <Route path="/news/:id" element={<NewsDetail />} />
                    <Route path="/success-story/:id" element={<SuccessStoryDetail />} />
                    <Route path="/company" element={<Company />} />
                    <Route path="/history" element={<Histroy />} />
                    <Route path="/registration" element={<Registration />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}
export default BasicRoute;